(function() {
    angular
        .module("devicesModule")
        .controller("DeviceTrackerHistoryTelemetryController", DeviceTrackerHistoryTelemetryController)

    DeviceTrackerHistoryTelemetryController.$inject = [
        "$rootScope",
        "$scope",
        "$stateParams",
        "historyService",
        "$filter",
        "DTOptionsBuilder",
        "DTColumnBuilder"
    ]

    function DeviceTrackerHistoryTelemetryController(
        $rootScope,
        $scope,
        $stateParams,
        historyService,
        $filter,
        DTOptionsBuilder,
        DTColumnBuilder
    ){
        "use strict"

        $rootScope.historySortTitle = "Telemetry"
        $rootScope.historyType = "telemetry"

        $scope.telemetryTab = undefined
        // $scope.dtInstance = {}
        $scope.telemetryHistory = []
        $scope.hoursHistory     = []

        $scope.hasVoltageSolar       = false
        $scope.hasVoltageActivator   = false
        $scope.hasVoltageSensor      = false
        $scope.hasLocalRssi          = false
        $scope.hasCurrentSolar       = false
        $scope.hasEngineRunHours     = false
        $scope.hasUsageHours         = false
        $scope.hasAverageSpeed       = false
        $scope.hasVehicleCount       = false
        $scope.hasBackupVoltage      = false
        $scope.hasDisplayActiveHours = false
        $scope.hasVictronElectrical  = false
        $scope.hasVictronTemperature = false
        $scope.hasVictronCapacity    = false
        $scope.hasVictronSolarYield  = false
        $scope.hasVictronDCLoad      = false
        $scope.hasVictronSolarDC     = false

        const getData = () => {

            const quantity = $scope.tracker.meta.isTrackerSolarLightTower ? 750 : 1000

            historyService.getTelemetryHistory("Tracker", $stateParams.tracker_id, $filter("date")($scope.startDate, "yyyy-MM-dd") || "", $filter("date")($scope.endDate, "yyyy-MM-dd") || "", 1, quantity).then((telemetry) => {

                telemetry = telemetry.reverse()

                if ($scope.tracker.meta.isTrackerSolarLightTower) {

                    historyService.getTelemetryHoursHistory($stateParams.tracker_id, $filter("date")($scope.startDate, "yyyy-MM-dd") || "", $filter("date")($scope.endDate, "yyyy-MM-dd") || "", quantity).then((hours) => {

                        hours = hours.reverse()
                        setChart(telemetry, hours)

                    })

                } else {

                    setChart(telemetry, [])

                }

                // if ($scope.dtInstance.reloadData !== undefined) {

                //     $scope.dtInstance.reloadData(null, true)

                // }
            })
        }

        const getTicks = (rows) => {

            const ticks = []

            for (let i = 0; i < rows.length; i++) {

                const row = rows[i]

                if (row === undefined || !row.hasOwnProperty("c") || row.c[0] === undefined || !row.c[0].hasOwnProperty("v") || !row.c[0].hasOwnProperty("f") || row.c[0].v === undefined || row.c[0].f === undefined) {
                    continue
                }

                const date    = row.c[0].v
                const display = row.c[0].f.slice(0, 10)

                // Include 1st date, last date, and any unique dates in between

                if (i === 0 || i === rows.length - 1 || ticks[ticks.length - 1].f !== display) {
                    ticks.push({
                        v: date,
                        f: display
                    })
                }
            }

            return ticks

        }

        // Google Chart Documentation:
        // https://developers.google.com/chart/interactive/docs

        const getDefaultChart = (rows, chartType) => {

            if (chartType === undefined) {
                chartType = "LineChart"
            }

            return {
                type: chartType,
                displayed: false,
                data: {
                    cols: [
                        {
                            type: "date"
                        }
                    ],
                    rows: rows
                },
                options: {
                    height: 400,
                    chartArea: {
                        width: "88%",
                        left: "8%",
                        height: "62%"
                    },
                    displayExactValues: true,
                    legend: {
                        position: "top",
                        alignment: "end"
                    },
                    hAxis: {
                        title: "CLICK & DRAG TO SELECT AN AREA TO ZOOM IN --- RIGHT-CLICK TO RESET",
                        titleTextStyle: {
                            fontSize: 11
                        },
                        textStyle: {
                            fontSize: 12
                        },
                        format: "yyyy-MM-dd",
                        slantedText: true,
                        slantedTextAngle: 38,
                        showTextEvery: 1,
                        ticks: getTicks(rows)
                    },
                    explorer: {
                        actions: ["dragToZoom", "rightClickToReset"],
                        axis: "horizontal",
                        keepInBounds: true,
                        maxZoomIn: 0.005,
                        maxZoomOut: 1
                    },
                    lineWidth: 1,
                    pointSize: 2
                }
            }
        }

        $scope.refreshDisplay = () => {

            // $scope.dtColumns[2].visible  = $scope.hasVoltageSolar
            // $scope.dtColumns[3].visible  = $scope.hasVoltageActivator
            // $scope.dtColumns[4].visible  = $scope.hasVoltageSensor
            // $scope.dtColumns[5].visible  = $scope.hasBackupVoltage
            // $scope.dtColumns[7].visible  = $scope.hasEngineRunHours
            // $scope.dtColumns[8].visible  = $scope.hasUsageHours
            // $scope.dtColumns[9].visible  = $scope.hasAverageSpeed
            // $scope.dtColumns[11].visible = $scope.hasLocalRssi
            // $scope.dtColumns[12].visible = $scope.hasVehicleCount
            // $scope.dtColumns[13].visible = $scope.hasDisplayActiveHours
            // $scope.dtColumns[14].visible = $scope.hasDisplayActiveHours

            if ($scope.telemetryTab === undefined) {
                $scope.telemetryTab = "electrical"
            }

            if ($scope.hasUsageHours === false && $scope.hasEngineRunHours === false && $scope.hasDisplayActiveHours === false && $scope.telemetryTab == "hours") {
                $scope.telemetryTab = "electrical"
            }

            // if ($scope.hasVoltageSensor) {
            //     $scope.dtColumns[2].sTitle = "Sensor Voltage"
            // }
        }

        const setChart = (telemetry, hours) => {

            let hasVoltageSolar       = false
            let hasVoltageActivator   = false
            let hasVoltageSensor      = false
            let hasCurrentSolar       = false
            let hasEngineRunHours     = false
            let hasUsageHours         = false
            let hasAverageSpeed       = false
            let hasLocalRssi          = false
            let hasVehicleCount       = false
            let hasBackupVoltage      = false
            let hasDisplayActiveHours = false
            let hasVictronElectrical  = false
            let hasVictronTemperature = false
            let hasVictronCapacity    = false
            let hasVictronSolarYield  = false
            let hasVictronDCLoad      = false
            let hasVictronSolarDC     = false
            let totalSolarYield       = 0
            let totalDCLoad           = 0

            $scope.telemetryHistory = telemetry
            $scope.hoursHistory     = hours
            // $scope.page = 1

            // $scope.max = historyService.getTotalHistory() || 0

            const average_speed_chart_data        = []
            const average_speed_diff_chart_data   = []
            const average_speed_weight_chart_data = []
            const electrical_chart_data           = []
            const rssi_chart_data                 = []
            const hours_chart_data                = []
            const vehicle_count_data              = []
            const victron_electrical_data         = []
            const victron_temperature_data        = []
            const victron_capacity_data           = []
            const victron_solar_yield_data        = []
            const victron_dc_load_data            = []
            const victron_solar_dc_data           = []

            for (const value of $scope.hoursHistory) {

                const updateDateDisplay = $rootScope.presentDateTime(value.registered_at, "NumericLongDate", $scope.tracker.device.timezone_iana)
                const updateDate        = $rootScope.adjustedDate(value.registered_at, $scope.tracker.device.timezone_iana)

                if (hasVictronSolarYield || value.hasOwnProperty("victron_solar_yield")) {

                    if (value.victron_solar_yield != null && value.victron_solar_yield != undefined) {
                        totalSolarYield += value.victron_solar_yield
                    }

                    hasVictronSolarYield = true

                    victron_solar_yield_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.victron_solar_yield || 0),
                                f: (value.victron_solar_yield || 0) + " Wh"
                            }
                        ]
                    })
                }

                if (hasVictronDCLoad || value.hasOwnProperty("victron_dc_load")) {

                    if (value.victron_dc_load != null && value.victron_dc_load != undefined) {
                        totalDCLoad += value.victron_dc_load
                    }

                    hasVictronDCLoad = true

                    victron_dc_load_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.victron_dc_load || 0),
                                f: (value.victron_dc_load || 0) + " Wh"
                            }
                        ]
                    })
                }

                if (hasVictronSolarDC || (value.hasOwnProperty("victron_solar_yield") && value.hasOwnProperty("victron_dc_load"))) {

                    hasVictronSolarDC = true

                    victron_solar_dc_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.victron_solar_yield || 0),
                                f: (value.victron_solar_yield || 0) + " Wh"
                            },
                            {
                                v: (value.victron_dc_load || 0),
                                f: (value.victron_dc_load || 0) + " Wh"
                            }
                        ]
                    })
                }
            }

            for (const value of $scope.telemetryHistory) {

                const updateDateDisplay = $rootScope.presentDateTime(value.updated_at, "NumericLongDate", value.timezone_iana)
                const updateDate        = $rootScope.adjustedDate(value.updated_at, value.timezone_iana)

                if (hasVoltageActivator || (value.hasOwnProperty("voltage_activator") && value.voltage_activator > 0)) {

                    hasVoltageActivator = true
                    electrical_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.voltage_activator || 0),
                                f: (value.voltage_activator || 0) + " V"
                            }
                        ]
                    })

                } else {

                    let voltage_value = value.voltage
                    if (value.hasOwnProperty("voltage_battery") && value.voltage_battery > 0) {
                        voltage_value = value.voltage_battery
                    }

                    electrical_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (voltage_value || 0),
                                f: (voltage_value || 0) + " V"
                            }
                        ]
                    })
                }

                if (hasVoltageSensor === true || (value.hasOwnProperty("voltage_sensor") && value.voltage_sensor > 0)) {
                    hasVoltageSensor = true
                    electrical_chart_data[electrical_chart_data.length - 1].c.push(
                        {
                            v: (value.voltage_sensor || 0),
                            f: (value.voltage_sensor || 0) + " V"
                        }
                    )
                }

                if (hasVoltageSolar === true || (value.hasOwnProperty("voltage_solar") && value.voltage_solar > 0)) {
                    hasVoltageSolar = true
                    electrical_chart_data[electrical_chart_data.length - 1].c.push(
                        {
                            v: (value.voltage_solar || 0),
                            f: (value.voltage_solar || 0) + " V"
                        }
                    )
                }

                if (hasBackupVoltage === true || (value.hasOwnProperty("voltage_backup") && value.voltage_backup > 0)) {
                    hasBackupVoltage = true
                    electrical_chart_data[electrical_chart_data.length - 1].c.push(
                        {
                            v: (value.voltage_backup || 0),
                            f: (value.voltage_backup || 0) + " V"
                        }
                    )
                }

                if (hasCurrentSolar === true || (value.hasOwnProperty("current_solar") && value.current_solar > 0)) {
                    hasCurrentSolar = true
                    electrical_chart_data[electrical_chart_data.length - 1].c.push(
                        {
                            v: (value.current_solar || 0),
                            f: (value.current_solar || 0) + " A"
                        }
                    )
                }

                if (hasEngineRunHours === true || (value.hasOwnProperty("engine_run_hours") && value.engine_run_hours > 0)) {
                    hasEngineRunHours = true
                    hours_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: value.engine_run_hours,
                                f: "" + value.engine_run_hours
                            }
                        ]
                    })
                }

                if (hasUsageHours === true || (value.hasOwnProperty("usage_hours") && value.usage_hours > 0)) {
                    hasUsageHours = true
                    hours_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: value.usage_hours,
                                f: "" + value.usage_hours
                            }
                        ]
                    })
                }

                if (hasDisplayActiveHours === true || value.hasOwnProperty("display_active_resettable")) {
                    const hasLifetimeData = value.hasOwnProperty("display_active_lifetime") && value.display_active_lifetime !== "Unknown"
                    if (value.display_active_resettable !== "Unknown") {
                        hasDisplayActiveHours = true
                        hours_chart_data.push({
                            c: [
                                {
                                    v: updateDate,
                                    f: updateDateDisplay
                                },
                                {
                                    v: value.display_active_resettable / 60,
                                    f: "" + $filter("number")((value.display_active_resettable / 60 || 0), 2)
                                }
                            ]
                        })

                        if (hasLifetimeData) {
                            hours_chart_data[hours_chart_data.length - 1].c.push(
                                {
                                    v: value.display_active_lifetime / 60,
                                    f: "" + $filter("number")((value.display_active_lifetime / 60 || 0), 2)
                                }
                            )
                        }

                    } else if (hasLifetimeData) {

                        hasDisplayActiveHours = true
                        hours_chart_data.push({
                            c: [
                                {
                                    v: updateDate,
                                    f: updateDateDisplay
                                },
                                {
                                    v: value.display_active_lifetime / 60,
                                    f: "" + $filter("number")((value.display_active_lifetime / 60 || 0), 2)
                                }
                            ]
                        })
                    }
                }

                if (hasVehicleCount === true || (value.hasOwnProperty("vehicle_count"))) {
                    hasVehicleCount = true
                    vehicle_count_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: value.vehicle_count,
                                f: "" + value.vehicle_count
                            }
                        ]
                    })
                }

                if (hasAverageSpeed === true || value.hasOwnProperty("average_speed_300")) {
                    hasAverageSpeed  = true

                    const average_speed_diff = (value.average_speed_030 - value.average_speed_060) +
                    (value.average_speed_060 - value.average_speed_090) +
                    (value.average_speed_090 - value.average_speed_120) +
                    (value.average_speed_120 - value.average_speed_150) +
                    (value.average_speed_150 - value.average_speed_180) +
                    (value.average_speed_180 - value.average_speed_210) +
                    (value.average_speed_210 - value.average_speed_240) +
                    (value.average_speed_240 - value.average_speed_270) +
                    (value.average_speed_270 - value.average_speed_300)

                    const average_speed_weighted = Math.floor(((value.average_speed_030 * 10) +
                    (value.average_speed_060 * 9) +
                    (value.average_speed_090 * 8) +
                    (value.average_speed_120 * 7) +
                    (value.average_speed_150 * 6) +
                    (value.average_speed_180 * 5) +
                    (value.average_speed_210 * 4) +
                    (value.average_speed_240 * 3) +
                    (value.average_speed_270 * 2) +
                    (value.average_speed_300)) / 54.0 * 100) / 100

                    average_speed_weight_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: average_speed_weighted,
                                f: "" + average_speed_weighted
                            }
                        ]
                    })

                    average_speed_diff_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: average_speed_diff,
                                f: "" + average_speed_diff
                            }
                        ]
                    })

                    average_speed_chart_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: value.average_speed_300,
                                f: "" + value.average_speed_300
                            },
                            {
                                v: value.average_speed_150,
                                f: "" + value.average_speed_150
                            },
                            {
                                v: value.average_speed_030,
                                f: "" + value.average_speed_030
                            }
                        ]
                    })
                }

                let rssi_v = -192.5
                let rssi_f = "Unknown"

                if (value.hasOwnProperty("rssi") && value.rssi < 0) {
                    rssi_v = value.rssi
                    rssi_f = value.rssi + " dBm"
                }
                rssi_chart_data.push({
                    c: [
                        {
                            v: updateDate,
                            f: updateDateDisplay
                        },
                    {
                            v: rssi_v,
                            f: rssi_f
                        }
                    ]
                })

                if (value.hasOwnProperty("rssi_activator") && value.rssi_activator < 0) {
                    rssi_chart_data[rssi_chart_data.length - 1].c.push(
                        {
                            v: value.rssi_activator,
                            f: value.rssi_activator + " dBm"
                        }
                    )
                }

                if (value.hasOwnProperty("rssi_sensor") && value.rssi_sensor < 0) {
                    rssi_chart_data[rssi_chart_data.length - 1].c.push(
                        {
                            v: value.rssi_sensor,
                            f: value.rssi_sensor + " dBm"
                        }
                    )
                }

                if (value.hasOwnProperty("rssi_local") && value.rssi_local < 0) {
                    hasLocalRssi = true
                    rssi_chart_data[rssi_chart_data.length - 1].c.push(
                        {
                            v: value.rssi_local,
                            f: value.rssi_local + " dBm"
                        }
                    )
                }

                if (hasVictronElectrical || value.hasOwnProperty("victron_battery_voltage") || value.hasOwnProperty("victron_battery_current") || value.hasOwnProperty("victron_solar_watts")) {

                    hasVictronElectrical = true

                    victron_electrical_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.victron_battery_voltage || 0),
                                f: (value.victron_battery_voltage || 0) + " V"
                            },
                            {
                                v: (value.victron_battery_current || 0),
                                f: (value.victron_battery_current || 0) + " A"
                            },
                            {
                                v: (value.victron_solar_watts || 0),
                                f: (value.victron_solar_watts || 0) + " A"
                            }
                        ]
                    })
                }

                if (hasVictronTemperature|| value.hasOwnProperty("victron_battery_temperature") || value.hasOwnProperty("victron_liu_temperature") || value.hasOwnProperty("victron_low_cell_temperature") || value.hasOwnProperty("victron_high_cell_temperature")) {

                    hasVictronTemperature = true

                    victron_temperature_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.victron_battery_temperature || 0),
                                f: (value.victron_battery_temperature || 0) + " C"
                            },
                            {
                                v: (value.victron_liu_temperature || 0),
                                f: (value.victron_liu_temperature || 0) + " C"
                            },
                            {
                                v: (value.victron_low_cell_temperature || 0),
                                f: (value.victron_low_cell_temperature || 0) + " C"
                            },
                            {
                                v: (value.victron_high_cell_temperature || 0),
                                f: (value.victron_high_cell_temperature || 0) + " C"
                            }
                        ]
                    })
                }

                if (hasVictronCapacity|| value.hasOwnProperty("victron_online_capacity")) {

                    hasVictronCapacity = true

                    victron_capacity_data.push({
                        c: [
                            {
                                v: updateDate,
                                f: updateDateDisplay
                            },
                            {
                                v: (value.victron_online_capacity || 0),
                                f: (value.victron_online_capacity || 0) + " Ah"
                            }
                        ]
                    })
                }
            }

            $scope.chartElectrical = getDefaultChart(electrical_chart_data)

            if (hasVoltageActivator) {
                $scope.chartElectrical.data.cols.push(
                    {
                        id: "voltage-id",
                        label: "Beacon Voltage",
                        type: "number"
                    }
                )
            } else {

                $scope.chartElectrical.data.cols.push(
                    {
                        id: "voltage-id",
                        label: "System Voltage",
                        type: "number"
                    }
                )
            }

            if (hasVoltageSensor) {
                $scope.chartElectrical.data.cols.push(
                    {
                        id: "voltage-sensor-id",
                        label: "Sensor Voltage",
                        type: "number"
                    }
                )
            }

            if (hasVoltageSolar === true) {
                $scope.chartElectrical.data.cols.push(
                    {
                        id: "voltage-solar-id",
                        label: "Solar Voltage",
                        type: "number"
                    }
                )
            }

            if (hasBackupVoltage === true) {
                $scope.chartElectrical.data.cols.push(
                    {
                        id: "voltage-backup-id",
                        label: "Backup Voltage",
                        type: "number"
                    }
                )
            }

            if (hasCurrentSolar === true) {
                $scope.chartElectrical.data.cols.push(
                    {
                        id: "current-solar-id",
                        label: "Solar Current",
                        type: "number"
                    }
                )
            }

            if (hasEngineRunHours === true || hasUsageHours === true || hasDisplayActiveHours === true) {

                $scope.chartHours = getDefaultChart(hours_chart_data)

                if (hasEngineRunHours === true) {
                    $scope.chartHours.data.cols.push({
                        id: "hours-id",
                        label: "Engine Run Hours",
                        type: "number"
                    })
                }

                if (hasUsageHours === true) {
                    $scope.chartHours.data.cols.push({
                        id: "hours-id",
                        label: "Usage Hours",
                        type: "number"
                    })
                }

                if (hasDisplayActiveHours === true) {
                    $scope.chartHours.data.cols.push({
                        id: "hours-id",
                        label: "Display Active Hours (Resettable)",
                        type: "number"
                    })
                    $scope.chartHours.data.cols.push({
                        id: "hours-id",
                        label: "Display Active Hours (Lifetime)",
                        type: "number"
                    })
                }
            }

            if (hasVehicleCount === true) {

                $scope.chartVehicleCount = getDefaultChart(vehicle_count_data)

                $scope.chartVehicleCount.data.cols.push({
                    id: "count-id",
                    label: "Vehicle Count",
                    type: "number"
                })
            }

            if (hasAverageSpeed ) {

                $scope.chartAverageSpeed = getDefaultChart(average_speed_chart_data.splice(Math.max(0, average_speed_chart_data.length - 120)))

                $scope.chartAverageSpeed.data.cols.push({
                    id: "average-speed-id",
                    label: "Avg. Speed 5 Min.",
                    type: "number"
                })

                $scope.chartAverageSpeed.data.cols.push({
                    id: "average-speed-id",
                    label: "Avg. Speed 2.5 Min.",
                    type: "number"
                })

                $scope.chartAverageSpeed.data.cols.push({
                    id: "average-speed-id",
                    label: "Avg. Speed .5 Min.",
                    type: "number"
                })
            }

            $scope.chartRSSI = getDefaultChart(rssi_chart_data)

            $scope.chartRSSI.data.cols.push({
                id: "rssi-id",
                label: hasVoltageActivator || hasVoltageSensor || hasLocalRssi ? "Modem RSSI" : "RSSI",
                type: "number"
            })

            if (hasVoltageActivator) {
                $scope.chartRSSI.data.cols.push(
                    {
                        id: "rssi-activator-id",
                        label: "Beacon RSSI",
                        type: "number"
                    }
                )
            }

            if (hasVoltageSensor) {
                $scope.chartRSSI.data.cols.push(
                    {
                        id: "rssi-sensor-id",
                        label: "Sensor RSSI",
                        type: "number"
                    }
                )
            }

            if (hasLocalRssi) {
                $scope.chartRSSI.data.cols.push(
                    {
                        id: "rssi-local-id",
                        label: "Local RSSI",
                        type: "number"
                    }
                )
            }

            if (hasVictronElectrical) {

                $scope.chartVictronElectrical = getDefaultChart(victron_electrical_data)

                $scope.chartVictronElectrical.data.cols.push({
                    id: "battery-voltage-id",
                    label: "Battery Voltage",
                    type: "number"
                })

                $scope.chartVictronElectrical.data.cols.push({
                    id: "battery-current-id",
                    label: "Battery Current",
                    type: "number"
                })

                $scope.chartVictronElectrical.data.cols.push({
                    id: "solar-watts-id",
                    label: "Solar Watts",
                    type: "number"
                })
            }

            if (hasVictronTemperature) {

                $scope.chartVictronTemperature = getDefaultChart(victron_temperature_data)

                $scope.chartVictronTemperature.data.cols.push({
                    id: "battery-temperature-id",
                    label: "Battery Temperature",
                    type: "number"
                })

                $scope.chartVictronTemperature.data.cols.push({
                    id: "liu-temperature-id",
                    label: "LIU Temperature",
                    type: "number"
                })

                $scope.chartVictronTemperature.data.cols.push({
                    id: "low-cell-temperature-id",
                    label: "Low Cell Temperature",
                    type: "number"
                })

                $scope.chartVictronTemperature.data.cols.push({
                    id: "high-cell-temperature-id",
                    label: "High Cell Temperature",
                    type: "number"
                })
            }

            if (hasVictronCapacity) {

                $scope.chartVictronCapacity = getDefaultChart(victron_capacity_data)

                $scope.chartVictronCapacity.data.cols.push({
                    id: "online-capacity-id",
                    label: "Online Capacity",
                    type: "number"
                })
            }

            const useWatts = totalSolarYield < 10000 && totalDCLoad < 10000
            const totalSolarYieldRounded = useWatts || totalSolarYield === 0 ? totalSolarYield : totalSolarYield < 10 ? Math.ceil(totalSolarYield / 10) / 100 : Math.floor(totalSolarYield / 10) / 100
            const totalDCLoadRounded     = useWatts || totalDCLoad     === 0 ? totalDCLoad     : totalDCLoad     < 10 ? Math.ceil(totalDCLoad     / 10) / 100 : Math.floor(totalDCLoad     / 10) / 100
            const totalSolarYieldDisplayValue = totalSolarYieldRounded + (useWatts ? " Wh" : " kWh")
            const totalDCLoadDisplayValue     = totalDCLoadRounded     + (useWatts ? " Wh" : " kWh")

            if (hasVictronSolarYield) {

                $scope.chartVictronSolarYield = getDefaultChart(victron_solar_yield_data, "ColumnChart")

                $scope.chartVictronSolarYield.data.cols.push({
                    id: "solar-yield-id",
                    label: "Solar Yield (TOTAL: " + totalSolarYieldDisplayValue  + ")",
                    type: "number"
                })
            }

            if (hasVictronDCLoad) {

                $scope.chartVictronDCLoad = getDefaultChart(victron_dc_load_data, "ColumnChart")

                $scope.chartVictronDCLoad.data.cols.push({
                    id: "dc-load-id",
                    label: "DC Load (TOTAL: " + totalDCLoadDisplayValue + ")",
                    type: "number"
                })
            }

            if (hasVictronSolarDC) {

                $scope.chartVictronSolarDC = getDefaultChart(victron_solar_dc_data, "ColumnChart")

                $scope.chartVictronSolarDC.data.cols.push({
                    id: "solar-yield-id",
                    label: "Solar Yield (TOTAL: " + totalSolarYieldDisplayValue + ")",
                    type: "number"
                })

                $scope.chartVictronSolarDC.data.cols.push({
                    id: "dc-load-id",
                    label: "DC Load (TOTAL: " + totalDCLoadDisplayValue + ")",
                    type: "number"
                })
            }

            $scope.hasVoltageSolar       = hasVoltageSolar
            $scope.hasVoltageActivator   = hasVoltageActivator
            $scope.hasVoltageSensor      = hasVoltageSensor
            $scope.hasCurrentSolar       = hasCurrentSolar
            $scope.hasEngineRunHours     = hasEngineRunHours
            $scope.hasUsageHours         = hasUsageHours
            $scope.hasAverageSpeed       = hasAverageSpeed
            $scope.hasLocalRssi          = hasLocalRssi
            $scope.hasVehicleCount       = hasVehicleCount
            $scope.hasBackupVoltage      = hasBackupVoltage
            $scope.hasDisplayActiveHours = hasDisplayActiveHours
            $scope.hasVictronElectrical  = hasVictronElectrical
            $scope.hasVictronTemperature = hasVictronTemperature
            $scope.hasVictronCapacity    = hasVictronCapacity
            $scope.hasVictronSolarYield  = hasVictronSolarYield
            $scope.hasVictronDCLoad      = hasVictronDCLoad
            $scope.hasVictronSolarDC     = hasVictronSolarDC

            $scope.refreshDisplay()

        }

        // $scope.dtOptions = DTOptionsBuilder.fromFnPromise(() => {
        //     return historyService.getTelemetryHistory("Tracker", $stateParams.tracker_id, $filter("date")($scope.startDate, "yyyy-MM-dd") || "", $filter("date")($scope.endDate, "yyyy-MM-dd") || "", 1, 1000).then((telemetry) => {
        //         setChart(telemetry)
        //         return telemetry
        //     })
        // })

        // $scope.dtOptions = $scope.dtOptions.withPaginationType("simple")
        // $scope.dtOptions = $scope.dtOptions.withOption("bFilter", false)
        // $scope.dtOptions = $scope.dtOptions.withOption("bAutoWidth", true)
        // $scope.dtOptions = $scope.dtOptions.withOption("order", [0, "desc"])
        // $scope.dtOptions = $scope.dtOptions.withOption("sDom", '<"top">rt<"clearfix"><"pull-left"l><"text-right"pfi><"clear">')
        // $scope.dtOptions = $scope.dtOptions.withOption("responsive", true)
        // $scope.dtOptions = $scope.dtOptions.withLanguage({
        //     sEmptyTable:     "No data available in table",
        //     sInfo:           "Showing _START_ to _END_ of _TOTAL_",
        //     sInfoEmpty:      "Showing 0 to 0 of 0",
        //     sLengthMenu:     "View _MENU_",
        //     sLoadingRecords: "Loading...",
        //     sZeroRecords:    "No matching records found",
        //     oPaginate: {
        //         sNext:     '<button class="btn btn-default pull-right"><i class="fa fa-angle-right"></i></button>',
        //         sPrevious: '<button class="btn btn-default"><i class="fa fa-angle-left"></i></button>'
        //     },
        //     oAria: {
        //         sSortAscending:  ": activate to sort column ascending",
        //         sSortDescending: ": activate to sort column descending"
        //     }
        // })

        // $scope.dtColumns = []

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Date").renderWith((data, type, full, meta) => {

        //         if (type === "display" || type === "filter") {

        //             const val = $rootScope.presentDateTime(data.updated_at, "NumericLongDate", data.timezone_iana).split("@")
        //             const d = "<span style='white-space: nowrap;'>" + val[0].trim()
        //             let t = ""
        //             if (val.length === 2) {
        //                 t = " " + val[1].trim()
        //             }
        //             return d + t + "</span>"

        //         }

        //         return $rootScope.adjustedDate(data.updated_at, data.timezone_iana)

        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("System Voltage").renderWith((data, type, full, meta) => {
        //         if (data.hasOwnProperty("voltage_battery") && data.voltage_battery > 0) {
        //             return $filter("number")((data.voltage_battery || 0), 2) + " V"
        //         }
        //         return $filter("number")((data.voltage || 0), 2) + " V"
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Solar Voltage").renderWith((data, type, full, meta) => {
        //         if (data.hasOwnProperty("voltage_solar")) {
        //             return $filter("number")(data.voltage_solar, 2) + " V"
        //         }
        //         return ""
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Beacon Voltage").renderWith((data, type, full, meta) => {
        //         if (data.hasOwnProperty("voltage_activator")) {
        //             return $filter("number")(data.voltage_activator, 2) + " V"
        //         }
        //         return ""
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Sensor Voltage").renderWith((data, type, full, meta) => {
        //         if (data.hasOwnProperty("voltage_sensor")) {
        //             return $filter("number")(data.voltage_sensor, 2) + " V"
        //         }
        //         return ""
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Backup Voltage").renderWith((data, type, full, meta) => {
        //         if (data.hasOwnProperty("voltage_backup")) {
        //             return $filter("number")(data.voltage_backup, 2) + " V"
        //         }
        //         return ""
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("GPS").renderWith((data, type, full, meta) => {
        //         return $filter("number")((data.gps.lat || 0), 4) + " / " +$filter("number")((data.gps.lon || 0), 4)
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Engine Run").renderWith((data, type, full, meta) => {
        //         if (data.hasOwnProperty("engine_run_hours")) {
        //             return $filter("number")(data.engine_run_hours, 2) + " Hours"
        //         }
        //         return ""
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Usage").renderWith((data, type, full, meta) => {
        //         if (data.hasOwnProperty("usage_hours")) {
        //             return $filter("number")(data.usage_hours, 2) + " Hours"
        //         }
        //         return ""
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Average Speed").renderWith((data, type, full, meta) => {
        //         if (data.hasOwnProperty("average_speed_300")) {
        //             return data.average_speed_300
        //         }
        //         return ""
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("RSSI").renderWith((data, type, full, meta) => {
        //         if (data.rssi < 0) {
        //             return (data.rssi || 0) + " dBm"
        //         }
        //         return "Unknown"
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Local RSSI").renderWith((data, type, full, meta) => {
        //         if (data.rssi_local < 0) {
        //             return (data.rssi_local || 0) + " dBm"
        //         }
        //         return "Unknown"
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Vehicle Count").renderWith((data, type, full, meta) => {
        //         return $filter("number")((data.vehicle_count || 0), 0)
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Display Active Hours (Resettable)").renderWith((data, type, full, meta) => {
        //         return $filter("number")((data.display_active_resettable / 60 || 0), 2)
        //     })
        // )

        // $scope.dtColumns.push(
        //     DTColumnBuilder.newColumn(null).withTitle("Display Active Hours (Lifetime)").renderWith((data, type, full, meta) => {
        //         return $filter("number")((data.display_active_lifetime / 60 || 0), 2)
        //     })
        // )

        // $scope.dtColumns[2].visible = false
        // $scope.dtColumns[3].visible = false
        // $scope.dtColumns[4].visible = false
        // $scope.dtColumns[6].visible = false
        // $scope.dtColumns[7].visible = false
        // $scope.dtColumns[8].visible = false

        $scope.getDeviceHistory = (startDate, endDate) => {
            $scope.changeStartDate(startDate)
            $scope.changeEndDate(endDate)
            $rootScope.minDate = startDate
            $rootScope.maxDate = endDate
            $scope.minDateOptions.maxDate = endDate
            $scope.maxDateOptions.minDate = startDate

            getData()

        }

        $scope.minStatus = {
            opened: false
        }
        $scope.maxStatus = {
            opened: false
        }

        $scope.today = () => {
            $scope.dt = new Date()
        }
        $scope.today()

        // $scope.dtMin = $rootScope.minDate
        // $scope.dtMax = $rootScope.maxDate || new Date()

        $scope.clear = () => {
            $scope.dt = null
        }

        $scope.openMin = () => {
            $scope.minStatus.opened = true
        }

        $scope.openMax = () => {
            $scope.maxStatus.opened = true
        }

        // $scope.minDateOptions = {
        //     formatYear: "yy",
        //     startingDay: 1,
        //     showWeeks: false,
        //     maxDate: $scope.dtMax
        // }

        // $scope.maxDateOptions = {
        //     formatYear: "yy",
        //     startingDay: 1,
        //     showWeeks: false,
        //     minDate: $scope.dtMin
        // }

        $scope.format = "MM/dd/yyyy"

        $scope.$watch("$root.pushedData", (pushedData) => {

            if ($rootScope.historyType === "telemetry") {

                if (pushedData.device.hasOwnProperty("device") && $scope.tracker.hasOwnProperty("device")) {

                    if (pushedData.device.device.id === $scope.tracker.device.id) {

                        if (pushedData.device.hasOwnProperty("telemetry")) {

                            $scope.hasVoltageSolar   = pushedData.device.telemetry.hasOwnProperty("voltage_solar")
                            $scope.hasVoltageActivator = pushedData.device.telemetry.hasOwnProperty("voltage_activator")
                            $scope.hasVoltageSensor  = pushedData.device.telemetry.hasOwnProperty("voltage_sensor")
                            $scope.hasCurrentSolar   = pushedData.device.telemetry.hasOwnProperty("current_solar")
                            $scope.hasEngineRunHours = pushedData.device.telemetry.hasOwnProperty("engine_run_hours")
                            $scope.hasUsageHours     = pushedData.device.telemetry.hasOwnProperty("usage_hours")
                            $scope.hasAverageSpeed   = pushedData.device.telemetry.hasOwnProperty("average_speed_300")
                            $scope.hasLocalRssi      = pushedData.device.telemetry.hasOwnProperty("rssi_local")
                            $scope.hasVehicleCount   = pushedData.device.telemetry.hasOwnProperty("vehicle_count")
                            $scope.hasBackupVoltage  = pushedData.device.telemetry.hasOwnProperty("voltage_backup")
                            $scope.hasDisplayActiveHours = (pushedData.device.telemetry.hasOwnProperty("display_active_resettable") && pushedData.device.telemetry.display_active_resettable !== "Unknown") || (pushedData.device.telemetry.hasOwnProperty("display_active_lifetime")  && pushedData.device.telemetry.display_active_lifetime !== "Unknown")

                            // TODO: pushed data does not include Hours

                            // $scope.telemetryHistory = [pushedData.device.telemetry].concat($scope.telemetryHistory)
                            $scope.telemetryHistory.push(pushedData.device.telemetry)

                            setChart($scope.telemetryHistory, $scope.hoursHistory)

                            // $scope.refreshDisplay()

                        }

                        // if ($scope.dtInstance.reloadData !== undefined) {

                        //     $scope.dtInstance.reloadData(null, true)

                        // }
                    }
                }
            }
        })

        $scope.$watch("retrievedTracker", (retrievedTracker) => {

            if (retrievedTracker) {
                getData()
            }
        })
    }
})()
